<div echarts [options]="options" class="demo-chart"></div>
<!-- <div id="barchart" style="width: 100%; height: 150px"></div>
<div>hello</div> -->
